export default __webpack_public_path__ + "static/media/manss.88a96f05.png";